//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { members_log } from '@/apis/members'
export default {
    data() {
        return {
            config: {
                //運動類型
                status: [
                    {
                        id: 1, name: "啟用",

                    },
                    {
                        id: 2, name: "停用",
                    }
                ],
            },
            searchQuery: {
                status: '',
                name: '',
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            },
            resultCurrentItem: {

            },
            resultVisible: false,
        }
    },
    created() {
        this.columns = [
            { title: '會員編碼', dataIndex: 'memberCode', key: 'memberCode', width: 200, },
            { title: '會員名稱', dataIndex: 'memberName', key: 'memberName', width: 200, },
            { title: '會員手機號', dataIndex: 'memberPhone', key: 'memberPhone', width: 160, },
            { title: 'IP', dataIndex: 'userIp', key: 'userIp', width: 160, },
            // { title: '操作參數', dataIndex: 'optReqParam', key: 'optReqParam', width: 330, },
            // { title: '返回內容', dataIndex: 'optResInfo', key: 'optResInfo', width: 330, scopedSlots: { customRender: 'optResInfo' } },
            // { title: '調用系統方法', dataIndex: 'methodName', key: 'methodName', width: 150, scopedSlots: { customRender: 'methodName' }, },
            { title: '系統類型', dataIndex: 'sysType', key: 'sysType', width: 100, scopedSlots: { customRender: 'sysType' }, },
            { title: '動作內容', dataIndex: 'methodRemark', key: 'methodRemark', width: 200 },
            { title: '創建時間', dataIndex: 'createdAt', key: 'createdAt', width: 180, },
            { title: '操作', key: 'operation', width: 130, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            // await this.onPageConfig();
            await this.onPageLoad();
        });
    },
    methods: {
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await members_log({
                    ...this.searchQuery,
                    pageNumber: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.records = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },

        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            e.preventDefault();
            this.onPageLoad();
        },
        handleShowResultInfo(item) {
            this.resultCurrentItem = item;
            this.resultVisible = true;
        }
    }
}
